import { createServerFn } from "@tanstack/react-start";

export type GameOverrideRow = {
  slug: string;
  name: string | null;
  logo_url: string | null;
  draw_schedule: string | null;
  description: string | null;
  updated_at?: string | null;
};

/**
 * Public, read-only list of CMS game overrides, cached server-side for a short
 * window. Every state/game page needs this list, so caching it collapses one
 * database round-trip per page view into one per minute per worker.
 */
export const getGameOverridesCached = createServerFn({ method: "GET" }).handler(
  async (): Promise<GameOverrideRow[]> => {
    const { cached } = await import("@/lib/server-cache");
    return cached("data:game-overrides", 60_000, async () => {
      const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
      const { data, error } = await supabaseAdmin
        .from("game_overrides")
        .select("slug, name, logo_url, draw_schedule, description, updated_at");
      if (error) throw new Error(error.message);
      return (data ?? []) as GameOverrideRow[];
    }, { staleWhileRevalidateMs: 10 * 60_000 });
  },
);
